import { paginationStyle,
  toggleButtonStyle,
  searchboxStyle,
  tableStyle,
  linkStyle,
  statusStyle,
  containerBudgetStyle,
  sharedBudgetGridWrapper,
  selectElementStyle,
  alertStyle } from '@bingads-webui-campaign-react/common-styles';
import { getCollapsiblePanelStyles } from '../../shared/styles';

export const getStyles = (components, theme, palette = {}) => ({
  collapsiblePanel: {
    ...getCollapsiblePanelStyles(components, theme),
    '& .predictive-matching-desc': {
      width: 566,
    },
  },
  formContainer: {
    display: 'flex',
    width: '100%',
    gap: '36px',
    '& .left-part': {
      minWidth: '966px',
    },
    '& .right-part': {
      width: '350px',
    },
    '& .section-title': {
      marginTop: '28px',
      marginBottom: '8px',
    },
    '& .section-description': {
      marginBottom: '16px',
    },
  },
  budgetAndBidSection: {
    ...searchboxStyle,
    ...toggleButtonStyle,
    ...linkStyle,
    ...containerBudgetStyle(theme),
    ...sharedBudgetGridWrapper(theme),
    ...tableStyle(theme),
    ...selectElementStyle(theme),
    ...alertStyle(theme),
    ...statusStyle(theme),
    '& .displayNone': {
      display: 'none',
    },
    '& .bid-strategy-selection-container': {
      '& .col-sm-6': {
        width: '100%',
        '& .form-control-static': {
          fontWeight: 600,
          '& a': {
            visibility: 'hidden',
          },
        },
      },
    },
    '& .original-portfolio-strategy-container': {
      width: '700px',
    },
    '& label[for="input-bid"]': {
      padding: '16px 0px 8px 0px',
    },
    ...paginationStyle({ palette }),
  },
});
